const COMING_SOON_STYLES = {
  "gummy-bears": { bg: "linear-gradient(135deg,#FFB300,#D32F2F)", emoji: "🧸" },
  "gummy-worms": { bg: "linear-gradient(135deg,#7CB342,#FFB300)", emoji: "🪱" },
  "mango-gummies": { bg: "linear-gradient(135deg,#FFB300,#F57C00)", emoji: "🥭" },
  "peach-rings": { bg: "linear-gradient(135deg,#FF9E80,#D32F2F)", emoji: "🍑" },
};

export function ProductImage({ p, className = "" }) {
  if (p.image) {
    return (
      <div className={`relative w-full h-full ${className}`}>
        <img src={p.image} alt={p.name} className="w-[85%] h-[85%] object-contain absolute inset-0 m-auto" />
        {p.size_oz && (
          <div className="absolute top-3 right-3 bg-[#D32F2F] text-white rounded-full w-14 h-14 flex flex-col items-center justify-center font-heading leading-none shadow-lg" data-testid={`oz-badge-${p.id}`}>
            <div className="text-xl">{p.size_oz}</div>
            <div className="text-[10px] tracking-widest">OZ</div>
          </div>
        )}
      </div>
    );
  }
  const style = COMING_SOON_STYLES[p.id] || { bg: "linear-gradient(135deg,#FFB300,#D32F2F)", emoji: "🍬" };
  return (
    <div className={`relative w-full h-full flex items-center justify-center ${className}`} style={{ background: style.bg }}>
      <div className="text-center px-4">
        <div className="text-6xl md:text-7xl" style={{ filter: "drop-shadow(0 4px 6px rgba(0,0,0,0.15))" }}>{style.emoji}</div>
        <div className="font-heading text-white text-lg md:text-xl uppercase tracking-wide mt-2 leading-tight">{p.name}</div>
      </div>
      <div className="absolute top-3 left-3 bg-[#1A1A1A] text-[#FFB300] text-[10px] tracking-widest uppercase px-2 py-1 font-heading">Coming soon</div>
      {p.size_oz && (
        <div className="absolute top-3 right-3 bg-white/95 text-[#1A1A1A] rounded-full w-14 h-14 flex flex-col items-center justify-center font-heading leading-none shadow-lg">
          <div className="text-xl">{p.size_oz}</div>
          <div className="text-[10px] tracking-widest">OZ</div>
        </div>
      )}
    </div>
  );
}
